enum LocalStorageKey {
  ColorMode = "ColorMode",
  LastUsedWalletName = "LastUsedWalletName",
  PublicKey = "PublicKey",
  ShouldShowCampaignIntroduction = "ShouldShowCampaignIntroduction",
}

export default LocalStorageKey;
